module.exports = __webpack_public_path__ + "img/hero.9f1fccd9.png";